import { __assign } from "tslib";
import { createHttpTestKit } from '../../http/test-kit';
import { createFakePostResponder } from '../../test-utils';
import { createTicketsSlaInsightsApi } from '.';
export var createTicketsSlaInsightsApiTestkit = function (parent) {
    var fakeHttp = createHttpTestKit();
    var api = createTicketsSlaInsightsApi(parent, fakeHttp);
    var tickets = parent + "/analytics/tickets";
    var slaBase = tickets + "/sla";
    var handler = {
        whenGetOverview: createFakePostResponder(fakeHttp, tickets + "/overview"),
        whenGetComplianceCumulative: createFakePostResponder(fakeHttp, slaBase + "/compliance/cumulative"),
        whenGetComplianceHistogram: createFakePostResponder(fakeHttp, slaBase + "/compliance/histogram"),
        whenGetElapsedTimeCumulative: createFakePostResponder(fakeHttp, slaBase + "/elapsedTime/cumulative"),
        whenGetElapsedTimeHistogram: createFakePostResponder(fakeHttp, slaBase + "/elapsedTime/histogram"),
        whenGetMissCountCumulative: createFakePostResponder(fakeHttp, slaBase + "/missCount/cumulative"),
        whenGetMissCountHistogram: createFakePostResponder(fakeHttp, slaBase + "/missCount/histogram"),
        whenGetMissTimeCumulative: createFakePostResponder(fakeHttp, slaBase + "/missTime/cumulative"),
        whenGetMissTimeHistogram: createFakePostResponder(fakeHttp, slaBase + "/missTime/histogram"),
    };
    return __assign(__assign({}, api), handler);
};
//# sourceMappingURL=testkit.js.map